export default __webpack_public_path__ + "static/media/Video_call.f40798b6.svg";